import { useCallback } from "react";

import { trackGAEvent } from "../util/analytics";
import { useAiAgentChatGaContext } from "./use-ai-agent-chat-ga-context";
import { useAiAgentConversationContext } from "../contexts/ai-agent-conversation-context";

export interface AiAgentLinkTracking {
  trackLinkDisplayed: (href: string, text?: string) => void;
}

/**
 * Dispara um evento de GA para cada link exibido pela IA no chat.
 * Usado pelo TrackedLink (renderizador de âncora do MarkdownViewer), no mount do <a>.
 * É um evento de impressão — mantém o `nonInteraction: true` padrão de `trackGAEvent`.
 */
export function useAiAgentLinkTracking(): AiAgentLinkTracking {
  const { page_path, userStatus, hashUserCpf } = useAiAgentChatGaContext();
  const { conversationId } = useAiAgentConversationContext();

  const trackLinkDisplayed = useCallback(
    (href: string, text?: string) => {
      trackGAEvent("link_displayed_by_ai_agent", {
        page_path,
        userStatus,
        hashUserCpf,
        conversation_id: conversationId ?? undefined,
        link_url: href,
        link_text: text,
        is_internal: href.startsWith("/"),
      });
    },
    [page_path, userStatus, hashUserCpf, conversationId]
  );

  return {
    trackLinkDisplayed,
  };
}
